export const categories = {
  state: {
    items: [],
  },
  mutations: {
    setCategories(state, value) {
      state.items = value.toSorted((categoryA, categoryB) => categoryA.order - categoryB.order)
    },
  },
  actions: {
    setCategories(context, payload) {
      context.commit('setCategories', payload)
    },
  },
}
